"use strict";

module.exports = function (relM) {
  relM.getAvailablePath = function (path) {
    var zip = relM.zip;
    if (!zip.files[path]) {
      return path;
    }
    var lastSlash = path.lastIndexOf("/");
    var lastPoint = path.lastIndexOf(".");
    var p = path.substr(0, lastSlash);
    var name = path.substr(lastSlash + 1, lastPoint - lastSlash - 1);
    var ext = path.substr(lastPoint + 1);
    var i = 0;
    var newPath;
    do {
      newPath = "".concat(p, "/").concat(name, "-").concat(i, ".").concat(ext);
      i++;
    } while (zip.files[newPath]);
    return newPath;
  };
  return relM;
};